import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import 'typeface-poppins';

export default createGlobalStyle`
  ${reset}

  * {
    box-sizing: border-box;
  }

  html, body { 
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, p, span, a {
    display: block;
    font-family: 'Poppins', sans-serif;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
  }

  h1 {
    font-size: 48px;
    font-weight: 600;
    line-height: 1.17;
    letter-spacing: -0.4px;
  }

  h2 {
    font-size: 40px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.4px;
  }

  h3 {
    font-size: 32px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: -0.2px;
  }

  h4 {
    font-size: 24px;
    line-height: 1.33;
    letter-spacing: -0.2px;
  }

  h5 {
    font-size: 20px;
    line-height: 1.4;
    letter-spacing: -0.2px;
  }

  p, span, a {
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: -0.1px;
  }

  a {
    cursor: pointer;
  }
`;
